import styled from 'styled-components';
import { Glyphicon } from 'react-bootstrap';

const EnvelopeIcon = styled(Glyphicon).attrs({
  glyph: 'home',
})``;

export default EnvelopeIcon;
